export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["invalidValue"] = "invalid-value";
    ErrorCode["incompleteValue"] = "incomplete-value";
    ErrorCode["missing"] = "missing";
    ErrorCode["companyIsClosed"] = "company-is-closed";
    ErrorCode["salesZoneIsClosed"] = "sales-zone-is-closed";
})(ErrorCode || (ErrorCode = {}));
